import React, { useState, useEffect } from "react";
import Link from "@/utils/link";
import { useRouter } from "next/router";

//import { Menu, Transition, Dialog } from "@headlessui/react";
import Menu from "@/ui/Menu";

import { useAuth } from "@/lib/auth";
import { readDocument, updateDocument } from "@/lib/db";

import {
    MenuIcon,
    LoginIcon,
    LogoutIcon,
    MailIcon,
    HomeIcon as HomeIconOutline,
} from "@heroicons/react/outline";
import { UserIcon, HomeIcon } from "@heroicons/react/solid";

import SignUpSignIn from "@/components/user/SignUpSignIn";
import { isSignedIn } from "@/components/user/UserUtils";
import { useLocalStorage } from "@/utils/hooks";
import { createCommunityPortalUser } from "@/components/communityPortal/community/communityUtils";

const CpHomeHeaderMenu = () => {
    const router = useRouter();
    const auth = useAuth();
    const [user, setUser] = useState({});
    const [openSignUp, setOpenSignUp] = useState(false);
    const [openSignIn, setOpenSignIn] = useState(false);
    const [signedInOnce, setSignedInOnce] = useLocalStorage("CpSignUp.signedInOnce", false);

    const userId = auth && auth.user ? auth.user.uid : "";
    const { company } = router.query;

    console.log("userId", userId);

    useEffect(() => {
        const getUser = async (uid) => {
            const user = await readDocument("users", uid);

            setUser(user);
        };

        if (userId) {
            getUser(userId);
        }
    }, [userId]);

    const handleSuccessfulSignIn = async (uid, email, name, _token) => {
        const _user = await readDocument("users", uid);

        console.log("CpHomeHeaderMenu handleSignUp", _user);

        if (_user.firstTime) {
            await createCommunityPortalUser(uid, email, _user.name, company);

            // if this is the first time the user has signed in, send a welcome email.
            const res = await fetch("/api/email/community-welcome-to-purple-door-finders", {
                method: "post",
                headers: {
                    "Content-Type": "application/json",
                    token: _token,
                },
                body: JSON.stringify(
                    {
                        title: `Welcome to Purple Door Finders, ${_user.name}!`,
                        preview: `Welcome to Purple Door Finders, ${_user.name}!`,
                        name: _user.name,
                    },
                    null,
                    2
                ),
            });

            await updateDocument("users", uid, {
                ..._user,
                firstTime: false,
            });
        }

        setSignedInOnce(true);

        // reload the page - in case the user tried to reload an expired page
        router.reload();
    };

    const handleSignOut = () => {
        auth.signOut("/community-portal");
        setOpenSignUp(false);
        setOpenSignIn(false);
    };

    return (
        <div>
            <Menu placement="bottom-end">
                <Menu.Button className="mr-1 sm:mr-2 sm:px-2">
                    <div className="px-3 py-1 flex items-center rounded-full text-primary-500 bg-white hover:bg-gray-200">
                        <MenuIcon className="mr-0 sm:mr-2 w-5 h-5" />
                        <HomeIcon className="hidden sm:block w-6 h-6 sm:w-7 sm:h-7 p-1 bg-primary-500 rounded-full text-white" />
                    </div>
                </Menu.Button>

                <Menu.Items
                    className={`absolute z-10 right-2 w-48 mt-3 origin-top-right text-gray-900 bg-gray-50 
                                 rounded overflow-hidden shadow-lg ring-1 ring-black ring-opacity-5
                                 focus:outline-none`}
                >
                    {/*isSignedIn(auth) ? (
                    <Menu.Item className="w-full">
                        <Link href="/my-account">
                            <a className="w-full flex items-center px-4 py-2 hover:bg-gray-200">
                                <UserIcon className="w-6 h-6 p-1 mr-4 text-white bg-primary-500 rounded-full" />
                                <span className="">
                                    {user && user.name ? user.name : "My Account"}
                                </span>
                            </a>
                        </Link>
                    </Menu.Item>
                ) : null*/}

                    <Menu.Item className="w-full">
                        <Link
                            href="/community-portal/my-communities"
                            disabled={!isSignedIn(auth)}
                        >
                            <a className="w-full flex items-center px-4 py-2 hover:bg-gray-200">
                                <HomeIconOutline className="w-6 h-6 mr-4 text-primary-400" />
                                <span className="">My Communities</span>
                            </a>
                        </Link>
                    </Menu.Item>

                    <hr />

                    {isSignedIn(auth) ? (
                        <Menu.Item className="w-full">
                            <button
                                className="w-full flex items-center px-4 py-2 hover:bg-gray-200"
                                onClick={handleSignOut}
                            >
                                <LogoutIcon className="w-6 h-6 mr-4 text-primary-400" />
                                <span className="">Sign Out</span>
                            </button>
                        </Menu.Item>
                    ) : (
                        <>
                            <Menu.Item className="w-full">
                                <button
                                    className="w-full flex items-center px-4 py-2 hover:bg-gray-200"
                                    onClick={() => setOpenSignIn(true)}
                                >
                                    <LoginIcon className="w-6 h-6 mr-4 text-primary-400" />
                                    <span className="">Sign In</span>
                                </button>
                            </Menu.Item>

                            <Menu.Item className="w-full">
                                <button
                                    className="w-full flex items-center px-4 py-2 hover:bg-gray-200"
                                    onClick={() => setOpenSignUp(true)}
                                >
                                    <MailIcon className="w-6 h-6 mr-4 text-primary-400" />
                                    <span className="">Sign Up</span>
                                </button>
                            </Menu.Item>
                        </>
                    )}
                </Menu.Items>
            </Menu>

            <SignUpSignIn
                openSignUp={openSignUp}
                openSignIn={openSignIn}
                setOpenSignUp={setOpenSignUp}
                setOpenSignIn={setOpenSignIn}
                onSuccessfulSignIn={handleSuccessfulSignIn}
                communityPortal={true}
            />
        </div>
    );
};

export default CpHomeHeaderMenu;
